import React, { useCallback } from "react";
import { useFormContext } from "react-hook-form";
import PropTypes from "prop-types";
import { get } from "lodash";

import ErrorMessage from "../ErrorMessage";

export function WithFormField(WrappedComponent) {
  const WithForm = ({
    name,
    label,
    description,
    required,
    showDescriptionBelow,
    hideError,
    ...props
  }) => {
    const {
      formState: { errors },
    } = useFormContext();
    const getDescription = useCallback(() => {
      return (
        description && (
          <div style={{ color: "#AAAAAA", fontSize: "12px" }}>
            {description}
          </div>
        )
      );
    }, [description]);
    const error = get(errors, `${name}.message`);

    return (
      <div style={{ paddingBottom: label && !hideError ? "1.7em" : undefined }}>
        {label && (
          <label
            style={{ fontWeight: "bold", display: "block" }}
            htmlFor={name}
          >
            {label}
            {required && <span style={{ color: "#BF3333" }}>*</span>}
          </label>
        )}
        {!showDescriptionBelow && getDescription()}
        <WrappedComponent
          id={name}
          name={name}
          required={required}
          style={{ marginTop: label ? "0.4em" : undefined }}
          {...props}
        />
        {showDescriptionBelow && getDescription()}
        <div style={{ position: "relative" }}>
          {error && !hideError && <ErrorMessage message={error} />}
        </div>
      </div>
    );
  };

  WithForm.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.node,
    description: PropTypes.node,
    required: PropTypes.bool,
    showDescriptionBelow: PropTypes.bool,
    hideError: PropTypes.bool,
  };

  WithForm.defaultProps = {
    label: undefined,
    description: undefined,
    required: false,
    showDescriptionBelow: false,
    hideError: false,
  };

  return WithForm;
}

export default WithFormField;
